import Divider from 'components/common/Divider';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Loading from 'components/economic-concret/components/loading';
import api from 'components/economic-concret/api/api';

const LoginForm = ({ hasLabel = false, layout = 'simple' }) => {

  const navigate = useNavigate();

  // State
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    setIsLoading(true);
    api.post('/login', { login: formData.email, password: formData.password })
      .then(returnFromApi => {
        sessionStorage.setItem('token', returnFromApi.data.token);
        sessionStorage.setItem('userEmail', formData.email);
        navigate('/');
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        setErrorMessage(error.response.data);
        console.error(error);
      });

  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Loading isToHidden={isLoading == false} />
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Email</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Email' : ''}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="email"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Senha</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? 'Senha' : ''}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      {/* <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <Form.Check type="checkbox" id="rememberMe" className="mb-0">
            <Form.Check.Input
              type="checkbox"
              name="remember"
              checked={formData.remember}
              onChange={e =>
                setFormData({
                  ...formData,
                  remember: e.target.checked
                })
              }
            />
            <Form.Check.Label className="mb-0 text-700">
              Remember me
            </Form.Check.Label>
          </Form.Check>
        </Col>

        <Col xs="auto">
    <Link className="fs-10 mb-0" to="/forgot-password">
        Esqueci minha senha
    </Link>
</Col>
      </Row> */}

      <Form.Group>
        <div className="mt-3">
          {errorMessage}
        </div>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.email || !formData.password}
        >
          Entrar
        </Button>
      </Form.Group>

    </Form>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};

export default LoginForm;
